/** Per-instance last picked scenario — survives Kaikki ↔ Skenaario ↔ Omat view switches. */

export function lastScenarioStorageKey(instanceId) {
  if (!instanceId) return null;
  return `kuutio_last_scenario_${instanceId}`;
}

export function getLastScenarioId(instanceId) {
  const key = lastScenarioStorageKey(instanceId);
  if (!key) return null;
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function setLastScenarioId(instanceId, scenarioId) {
  const key = lastScenarioStorageKey(instanceId);
  if (!key || !scenarioId) return;
  try {
    sessionStorage.setItem(key, scenarioId);
  } catch {
    /* storage unavailable */
  }
}

export function clearLastScenarioId(instanceId) {
  const key = lastScenarioStorageKey(instanceId);
  if (!key) return;
  try {
    sessionStorage.removeItem(key);
  } catch {
    /* storage unavailable */
  }
}
